import { render } from "./PWAModal.vue?vue&type=template&id=be20b764&scoped=true"
import script from "./PWAModal.vue?vue&type=script&lang=js"
export * from "./PWAModal.vue?vue&type=script&lang=js"

import "./PWAModal.vue?vue&type=style&index=0&id=be20b764&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be20b764"]])

export default __exports__